/* eslint-disable */
import * as Types from "./types";

import { TypedDocumentNode as DocumentNode } from "@graphql-typed-document-node/core";
export type GqlMatterTypeCategoriesQueryVariables = Types.Exact<{
  teamUri?: Types.InputMaybe<Types.Scalars["ID"]["input"]>;
}>;

export type GqlMatterTypeCategoriesQuery = {
  __typename: "Query";
  matterTypeCategories: Array<string>;
};

export const MatterTypeCategoriesDocument = {
  kind: "Document",
  definitions: [
    {
      kind: "OperationDefinition",
      operation: "query",
      name: { kind: "Name", value: "matterTypeCategories" },
      variableDefinitions: [
        {
          kind: "VariableDefinition",
          variable: {
            kind: "Variable",
            name: { kind: "Name", value: "teamUri" },
          },
          type: { kind: "NamedType", name: { kind: "Name", value: "ID" } },
        },
      ],
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "Field",
            name: { kind: "Name", value: "matterTypeCategories" },
            arguments: [
              {
                kind: "Argument",
                name: { kind: "Name", value: "teamUri" },
                value: {
                  kind: "Variable",
                  name: { kind: "Name", value: "teamUri" },
                },
              },
            ],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<
  GqlMatterTypeCategoriesQuery,
  GqlMatterTypeCategoriesQueryVariables
>;
